module.exports = __webpack_public_path__ + "static/media/appload.3e6cb08f.png";